import { useQuery } from 'urql';
import { Query, QueryStructureArgs } from 'api';
import { GET_STRUCTURE_ANCESTORS } from 'api/graphql/queries/structure';

export type StructureQueryType = Pick<Query, 'structure'>;

export const useGetAncestors = (variables: QueryStructureArgs) => {
    const [{ fetching, data, error }, reexecuteQuery] = useQuery<StructureQueryType>({
        query: GET_STRUCTURE_ANCESTORS,
        variables,
    });

    return { fetching, data, error, reexecuteQuery };
};
